import {
    type ViewStyle,
    type TextStyle,
    StyleSheet
} from "react-native";
import type {
    TraceToolCallDynamicStyleType
} from "./type";
import type {
    Mutable
} from "../../../../types";

const stylesheet = StyleSheet.create({
    container: {
        flexDirection: "column",
        alignItems: "stretch",
        minWidth: 0
    },
    meta: {
        alignItems: "center",
        flexDirection: "row",
        flexWrap: "wrap"
    },
    alert: {
        alignSelf: "stretch"
    }
});

export const useStyles = ({
    typography,
    spaces
}: TraceToolCallDynamicStyleType) => {
    const styles = {
        name: {
            lineHeight: typography.bodySmallSize.lineHeight,
            fontSize: typography.bodySmallSize.fontSize
        } as Mutable<TextStyle>,
        meta: {
            columnGap: spaces.spacingSm,
            rowGap: spaces.spacingXs
        } as Mutable<ViewStyle>
    };

    return styles;
};
export default stylesheet;
